import { render, staticRenderFns } from "./ServiceDetailTable.vue?vue&type=template&id=6f040aec&scoped=true&"
import script from "./ServiceDetailTable.vue?vue&type=script&lang=ts&"
export * from "./ServiceDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceDetailTable.vue?vue&type=style&index=0&id=6f040aec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f040aec",
  null
  
)

export default component.exports